import React from 'react';
import DetalhesImportacaoPage, {
    colunaCliente,
    colunaProcessado,
    colunaErros,
    colunaStatusDetalhe,
} from '../../../components/importacoes/DetalhesImportacaoPage';

const columns = [
    colunaCliente,
    colunaProcessado,
    colunaErros,
    { key: 'competencia', label: 'Competência', render: (item) => item?.competencia || '—' },
    { key: 'tipo', label: 'Arquivo', render: (item) => item?.tipo || '—' },
    colunaStatusDetalhe,
];

const DetalhesImportacao = () => (
    <DetalhesImportacaoPage
        endpoint="detalhes/importacao/demonstracoes"
        breadcrumbs={[{ label: 'Dashboard', to: '/dashboard' }, { label: 'Demonstrações contábeis', to: '/demonstracoes-contabeis' }, { label: 'Detalhes da importação' }]}
        columns={columns}
    />
);

export default DetalhesImportacao;
